module.exports = __webpack_public_path__ + "static/media/slider-backgroundd-1024x543.f302a8c6.jpg";